import React from 'react'
import styles from './MediaGrid.module.scss'

interface MediaGridProps {
  children: React.ReactNode
  className?: never
}

export const MediaGrid: React.FC<MediaGridProps> = ({ children }) => (
  <div className={styles.grid}>{children}</div>
)
